let introduction = [
  // 下架
  // {
  //   path: '/giftIntroduction',
  //   name: 'giftIntroduction',
  //   component: () => import('@/pages/introductionPages/giftIntroduction/index.vue'),
  //   meta: {
  //     title: '礼物介绍'
  //   }
  // },
  // {
  //   path: '/reward',
  //   name: 'reward',
  //   component: () => import('@/pages/introductionPages/reward/index.vue'),
  //   meta: {
  //     title: '任务介绍'
  //   }
  // },
  // {
  //   path: '/help',
  //   name: 'help',
  //   component: () => import('@/pages/introductionPages/help/index.vue'),
  //   meta: {
  //     title: '助力介绍'
  //   }
  // },
  // 下架
  // {
  //   path: '/jackpot',
  //   name: 'jackpot',
  //   component: () => import('@/pages/introductionPages/jackpot/index.vue'),
  //   meta: {
  //     title: '奖池介绍'
  //   }
  // },
  // 下架
  // {
  //   path: '/blindBoxB',
  //   name: 'blindBoxB',
  //   component: () => import('@/pages/introductionPages/blindBoxB/index.vue'),
  //   meta: {
  //     title: '盲盒介绍'
  //   }
  // },
  // {
  //   path: '/blindBoxC',
  //   name: 'blindBoxC',
  //   component: () => import('@/pages/introductionPages/blindBoxC/index.vue'),
  //   meta: {
  //     title: '盲盒介绍'
  //   }
  // },
  // {
  //   path: '/boxIntroduceB',
  //   name: 'boxIntroduceB',
  //   component: () => import('@/pages/introductionPages/boxIntroduceB/index.vue'),
  //   meta: {
  //     title: '宝箱介绍'
  //   }
  // },
  // {
  //   path: '/boxIntroduceC',
  //   name: 'boxIntroduceC',
  //   component: () => import('@/pages/introductionPages/boxIntroduceC/index.vue'),
  //   meta: {
  //     title: '宝箱介绍'
  //   }
  // },
  {
    path: '/cpBox',
    name: 'cpBox',
    component: () => import('@/pages/introductionPages/cpBox/index.vue'),
    meta: {
      title: 'CP陪伴礼物介绍'
    }
  },
  {
    path: '/cpBoxTest',
    name: 'cpBoxTest',
    component: () => import('@/pages/introductionPages/cpBox/test.vue'),
    meta: {
      title: 'CP陪伴礼物介绍'
    }
  },
  // {
  //   path: '/cpIntroduce',
  //   name: 'cpIntroduce',
  //   component: () => import('@/pages/introductionPages/cpIntroduce/index.vue'),
  //   meta: {
  //     title: 'CP战介绍'
  //   }
  // },
  // {    
  //   path: '/cpValue',
  //   name: 'cpValue',
  //   component: () => import('@/pages/introductionPages/cpValue/index.vue'),
  //   meta: {
  //     title: 'CP热力值说明'
  //   }
  // },
  {
    path: '/tigerRule',
    name: 'tigerRule',
    component: () => import('@/pages/introductionPages/tigerRule/index.vue'),
    meta: {
      title: '精灵折扣商店介绍'
    }
  },
  {
    path: '/tigerRuleOld',
    name: 'tigerRuleOld',
    component: () => import('@/pages/introductionPages/tigerRule/oldIndex.vue'),
    meta: {
      title: '精灵折扣商店介绍'
    }
  },
  // 2023-10-10需求砸金虎介绍
  {
    path: '/tigerRuleOld2',
    name: 'tigerRuleOld2',
    component: () => import('@/pages/introductionPages/tigerRule/oldTiger.vue'),
    meta: {
      title: '砸金虎介绍'
    }
  },
  {
    path: '/speedPage',
    name: 'speedPage',
    component: () => import('@/pages/introductionPages/speedPage/index.vue'),
    meta: {
      title: '加速合成'
    }
  },
  {
    path: '/circleScorePool',
    name: 'circleScorePool',
    component: () => import('@/pages/introductionPages/circleScorePool/index.vue'),
    meta: {
      title: '积分池说明'
    }
  },
  // 已下掉
  // {
  //   path: '/host',
  //   name: 'host',
  //   component: () => import('@/pages/introductionPages/host/index.vue'),
  //   meta: {
  //     title: '成为主持'
  //   }
  // },
  // {
  //   path: '/exchange',
  //   name: 'exchange',
  //   component: () => import('@/pages/introductionPages/exchange/index.vue'),
  //   meta: {
  //     title: '兑换流程'
  //   }
  // },
  {
    path: '/remeber_directions',
    name: 'remeber_directions',
    component: () => import('@/pages/introductionPages/cpRemember/index.vue'),
    meta: {
      title: '关于纪念日'
    }
  },
  {
    path: '/dragonDialog',
    name: 'dragonDialog',
    component: () => import('@/pages/introductionPages/dragonDialog/index.vue'),
    meta: {
      title: '金龙赐福活动'
    }
  },
  {
    path: '/dragonRule',
    name: 'dragonRule',
    component: () => import('@/pages/introductionPages/dragonRule/index.vue'),
    meta: {
      title: '砸金龙规则'
    }
  },
  {
    path: '/dragonDialog',
    name: 'dragonDialog',
    component: () => import('@/pages/introductionPages/dragonDialog/index.vue'),
    meta: {
      title: '金龙赐福活动'
    }
  },
  {
    path: '/birthdayPartyIntro',
    name: 'birthdayPartyIntro',
    component: () => import('@/pages/introductionPages/birthdayParty/index.vue'),
    meta: {
      title: '生日派对介绍'
    }
  },
  {
    path: '/intimateFriendGifts',
    name: 'intimateFriendGifts',
    component: () => import('@/pages/introductionPages/intimateFriendGifts/index.vue'),
    meta: {
      title: '密友陪伴礼物介绍'
    }
  },
  {
    path: '/intimateFriendRule',
    name: 'intimateFriendRule',
    component: () => import('@/pages/introductionPages/intimateFriendRule/index.vue'),
    meta: {
      title: '密友攻略'
    }
  }
]

export {
  introduction
}